<template>
    <div>
        <div class="category__bubble js-category__bubble"></div>
        <div class="category__container single__category__container">
            <div class="category-breadcrumb">
                <slot name="breadcrumb"></slot>
            </div>
        </div>
        <span id="single__parent-cat-id" class="d-none">{{ currentVariation.ids.categories.all[0] }}</span>
        <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
            <div class="single container-max page-content">
                <div class="single__main">

                    <div class="row m-t-3 single__inner-container">
                        <div class="single-leftside">
                            <div class="single-leftside__scrollable">
                                <slot name="image-carousel"></slot>
                                <div v-if="!$store.state.viewport.isMobile" class="single__fullscreen">
                                    <a href="#">
                                        <svg width="12px" height="11px">
                                            <use xlink:href="#svg_zoom" xmlns:xlink="https://www.w3.org/1999/xlink">
                                            </use>
                                        </svg>&nbsp;&nbsp;{{ $translate("Froschkoenig::Template.singleFullscreen")
                                        }}</a>
                                </div>

                                <div v-if="$store.state.viewport.isLg || $store.state.viewport.isXl">
                                    <slot name="crosssellingbasket"></slot>
                                </div>



                                <div class="single__video-doc-headline"
                                    v-if="hasDoc1 || hasDoc2 || hasVideo1 || hasVideo2">{{
                                    $translate("Froschkoenig::Template.singleDocVideoHeadline") }}</div>
                                <div class="single__video-doc-wrapper"
                                    v-if="hasDoc1 || hasDoc2 || hasVideo1 || hasVideo2">
                                    <a v-if="hasVideo1" @click="toggleModal(1)" class="single-leftside__video"
                                        target="_blank">
                                        <img height="112" width="112" loading="lazy"
                                            :src="'https://img.youtube.com/vi/'+ currentVariation.item.free3 +'/1.jpg'"
                                            alt="">
                                        <div>
                                            <svg width="25px" height="31px" viewBox="0 0 25 31" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink">

                                                <title>Triangle 2</title>
                                                <g id="Redesign-2022" stroke="none" stroke-width="1" fill="none"
                                                    fill-rule="evenodd">
                                                    <g id="xl-article-crossselling-redesign-2022-01-1-copy"
                                                        transform="translate(-307.000000, -949.000000)" fill="#95C300"
                                                        fill-rule="nonzero">
                                                        <g id="00-links-" transform="translate(263.000000, 901.000000)">
                                                            <g id="00-video" transform="translate(0.000000, 23.000000)">
                                                                <polygon id="Triangle-2"
                                                                    points="68.6933333 40.32 44.8 55.2533333 44.8 25.3866667">
                                                                </polygon>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <span>
                                                {{ $translate("Froschkoenig::Template.singleVideo") }}
                                            </span>
                                        </div>
                                    </a>
                                    <a v-if="hasVideo2" @click="toggleModal(2)" class="single-leftside__video"
                                        target="_blank">
                                        <img height="112" width="112" loading="lazy"
                                            :src="'https://img.youtube.com/vi/'+ currentVariation.item.free14 +'/1.jpg'"
                                            alt="">
                                        <div>
                                            <svg width="25px" height="31px" viewBox="0 0 25 31" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink">

                                                <title>Triangle 2</title>
                                                <g id="Redesign-2022" stroke="none" stroke-width="1" fill="none"
                                                    fill-rule="evenodd">
                                                    <g id="xl-article-crossselling-redesign-2022-01-1-copy"
                                                        transform="translate(-307.000000, -949.000000)" fill="#95C300"
                                                        fill-rule="nonzero">
                                                        <g id="00-links-" transform="translate(263.000000, 901.000000)">
                                                            <g id="00-video" transform="translate(0.000000, 23.000000)">
                                                                <polygon id="Triangle-2"
                                                                    points="68.6933333 40.32 44.8 55.2533333 44.8 25.3866667">
                                                                </polygon>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <span>
                                                {{ $translate("Froschkoenig::Template.singleVideo") }}
                                            </span>
                                        </div>
                                    </a>

                                    <portal v-if="videoContent === 1" to="singlevideo">
                                        <iframe width="100%" height="360px"
                                            :src="'https://www.youtube.com/embed/' + currentVariation.item.free3"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowfullscreen></iframe>
                                    </portal>

                                    <portal v-if="videoContent === 2" to="singlevideo">
                                        <iframe width="100%" height="360px"
                                            :src="'https://www.youtube.com/embed/' + currentVariation.item.free14"
                                            frameborder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            allowfullscreen></iframe>
                                    </portal>

                                    <a v-if="hasDoc1" :href="currentVariation.item.free1" class="single-leftside__doc"
                                        target="_blank">
                                        <img height="112" width="112" loading="lazy"
                                            :src="pluginPath + '/images/Prospektbild.jpeg'" alt="Doc">
                                        <div>
                                            <svg width="26px" height="27px" viewBox="0 0 26 27" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <g id="Redesign-2022" stroke="none" stroke-width="1" fill="none"
                                                    fill-rule="evenodd">
                                                    <g id="xl-article-crossselling-redesign-2022-01-1-copy"
                                                        transform="translate(-550.000000, -954.000000)" fill="#95C300"
                                                        fill-rule="nonzero">
                                                        <g id="00-links-" transform="translate(263.000000, 901.000000)">
                                                            <g id="Group-7"
                                                                transform="translate(244.000000, 23.000000)">
                                                                <g id="flyer-(1)"
                                                                    transform="translate(43.000000, 30.500000)">
                                                                    <path
                                                                        d="M23.4132031,0 L10.745668,0 C9.31927344,0 8.15882031,1.16045312 8.15882031,2.58684766 L8.15882031,3.65127344 L2.53454297,3.65127344 C1.13699219,3.65127344 0,4.78826562 0,6.18581641 L0,23.465457 C0,24.8630078 1.13699219,26 2.53454297,26 L15.3065859,26 C16.7041367,26 17.8411289,24.8630078 17.8411289,23.465457 L17.8411289,22.3487773 L23.4132031,22.3487773 C24.8395977,22.3487773 26,21.1883242 26,19.7619297 L26,2.58684766 C26,1.16045312 24.8395469,0 23.4132031,0 Z M16.3176914,23.465457 C16.3176914,24.0229844 15.8640625,24.4765625 15.3065859,24.4765625 L2.53454297,24.4765625 C1.97701563,24.4765625 1.5234375,24.0229844 1.5234375,23.465457 L1.5234375,6.18581641 C1.5234375,5.62828906 1.97701563,5.17471094 2.53454297,5.17471094 L15.3065859,5.17471094 C15.8641133,5.17471094 16.3176914,5.62828906 16.3176914,6.18581641 L16.3176914,23.465457 Z M24.4765625,19.7619297 C24.4765625,20.3483008 23.9995234,20.8253398 23.4132031,20.8253398 L17.8411289,20.8253398 L17.8411289,6.18581641 C17.8411289,4.78826563 16.7041367,3.65127344 15.3065859,3.65127344 L9.68230859,3.65127344 L9.68230859,2.58684766 C9.68230859,2.00047656 10.1593477,1.5234375 10.7457187,1.5234375 L23.4132031,1.5234375 C23.9995234,1.5234375 24.4765625,2.00047656 24.4765625,2.58684766 L24.4765625,19.7619297 Z"
                                                                        id="Shape"></path>
                                                                    <path
                                                                        d="M14.7,13.7503437 L4.2,13.7503437 C3.64771525,13.7503437 3.2,13.3026285 3.2,12.7503437 L3.2,7.75034375 C3.2,7.198059 3.64771525,6.75034375 4.2,6.75034375 L13.7,6.75034375 C14.2522847,6.75034375 14.7,7.198059 14.7,7.75034375 L14.7,13.7503437 L14.7,13.7503437 Z"
                                                                        id="Shape"></path>
                                                                    <path
                                                                        d="M14.0083125,16.6398984 L3.83281641,16.6398984 C3.41214453,16.6398984 3.07109766,16.9809453 3.07109766,17.4016172 C3.07109766,17.8222891 3.41214453,18.1633359 3.83281641,18.1633359 L14.0083633,18.1633359 C14.4290352,18.1633359 14.770082,17.8222891 14.770082,17.4016172 C14.770082,16.9809453 14.4290352,16.6398984 14.0083125,16.6398984 Z"
                                                                        id="Path"></path>
                                                                    <path
                                                                        d="M14.0083125,19.1570234 L3.83281641,19.1570234 C3.41214453,19.1570234 3.07109766,19.4980703 3.07109766,19.9187422 C3.07109766,20.3394141 3.41214453,20.6804609 3.83281641,20.6804609 L14.0083633,20.6804609 C14.4290352,20.6804609 14.770082,20.3394141 14.770082,19.9187422 C14.770082,19.4980703 14.4290352,19.1570234 14.0083125,19.1570234 Z"
                                                                        id="Path"></path>
                                                                    <path
                                                                        d="M13.9709883,21.6740977 L11.1720273,21.6740977 C10.7513555,21.6740977 10.4103086,22.0151445 10.4103086,22.4358164 C10.4103086,22.8564883 10.7513555,23.1975352 11.1720273,23.1975352 L13.9709883,23.1975352 C14.3916602,23.1975352 14.732707,22.8564883 14.732707,22.4358164 C14.732707,22.0151445 14.3916602,21.6740977 13.9709883,21.6740977 Z"
                                                                        id="Path"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <span>
                                                {{ $translate("Froschkoenig::Template.singleDoc") }}
                                            </span>
                                        </div>
                                    </a>
                                    <a v-if="hasDoc2" :href="currentVariation.item.free2" class="single-leftside__doc"
                                        target="_blank">
                                        <img height="112" width="112" loading="lazy"
                                            :src="pluginPath + '/images/Prospektbild.jpeg'" alt="Doc">
                                        <div>
                                            <svg width="26px" height="27px" viewBox="0 0 26 27" version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink">
                                                <g id="Redesign-2022" stroke="none" stroke-width="1" fill="none"
                                                    fill-rule="evenodd">
                                                    <g id="xl-article-crossselling-redesign-2022-01-1-copy"
                                                        transform="translate(-550.000000, -954.000000)" fill="#95C300"
                                                        fill-rule="nonzero">
                                                        <g id="00-links-" transform="translate(263.000000, 901.000000)">
                                                            <g id="Group-7"
                                                                transform="translate(244.000000, 23.000000)">
                                                                <g id="flyer-(1)"
                                                                    transform="translate(43.000000, 30.500000)">
                                                                    <path
                                                                        d="M23.4132031,0 L10.745668,0 C9.31927344,0 8.15882031,1.16045312 8.15882031,2.58684766 L8.15882031,3.65127344 L2.53454297,3.65127344 C1.13699219,3.65127344 0,4.78826562 0,6.18581641 L0,23.465457 C0,24.8630078 1.13699219,26 2.53454297,26 L15.3065859,26 C16.7041367,26 17.8411289,24.8630078 17.8411289,23.465457 L17.8411289,22.3487773 L23.4132031,22.3487773 C24.8395977,22.3487773 26,21.1883242 26,19.7619297 L26,2.58684766 C26,1.16045312 24.8395469,0 23.4132031,0 Z M16.3176914,23.465457 C16.3176914,24.0229844 15.8640625,24.4765625 15.3065859,24.4765625 L2.53454297,24.4765625 C1.97701563,24.4765625 1.5234375,24.0229844 1.5234375,23.465457 L1.5234375,6.18581641 C1.5234375,5.62828906 1.97701563,5.17471094 2.53454297,5.17471094 L15.3065859,5.17471094 C15.8641133,5.17471094 16.3176914,5.62828906 16.3176914,6.18581641 L16.3176914,23.465457 Z M24.4765625,19.7619297 C24.4765625,20.3483008 23.9995234,20.8253398 23.4132031,20.8253398 L17.8411289,20.8253398 L17.8411289,6.18581641 C17.8411289,4.78826563 16.7041367,3.65127344 15.3065859,3.65127344 L9.68230859,3.65127344 L9.68230859,2.58684766 C9.68230859,2.00047656 10.1593477,1.5234375 10.7457187,1.5234375 L23.4132031,1.5234375 C23.9995234,1.5234375 24.4765625,2.00047656 24.4765625,2.58684766 L24.4765625,19.7619297 Z"
                                                                        id="Shape"></path>
                                                                    <path
                                                                        d="M14.7,13.7503437 L4.2,13.7503437 C3.64771525,13.7503437 3.2,13.3026285 3.2,12.7503437 L3.2,7.75034375 C3.2,7.198059 3.64771525,6.75034375 4.2,6.75034375 L13.7,6.75034375 C14.2522847,6.75034375 14.7,7.198059 14.7,7.75034375 L14.7,13.7503437 L14.7,13.7503437 Z"
                                                                        id="Shape"></path>
                                                                    <path
                                                                        d="M14.0083125,16.6398984 L3.83281641,16.6398984 C3.41214453,16.6398984 3.07109766,16.9809453 3.07109766,17.4016172 C3.07109766,17.8222891 3.41214453,18.1633359 3.83281641,18.1633359 L14.0083633,18.1633359 C14.4290352,18.1633359 14.770082,17.8222891 14.770082,17.4016172 C14.770082,16.9809453 14.4290352,16.6398984 14.0083125,16.6398984 Z"
                                                                        id="Path"></path>
                                                                    <path
                                                                        d="M14.0083125,19.1570234 L3.83281641,19.1570234 C3.41214453,19.1570234 3.07109766,19.4980703 3.07109766,19.9187422 C3.07109766,20.3394141 3.41214453,20.6804609 3.83281641,20.6804609 L14.0083633,20.6804609 C14.4290352,20.6804609 14.770082,20.3394141 14.770082,19.9187422 C14.770082,19.4980703 14.4290352,19.1570234 14.0083125,19.1570234 Z"
                                                                        id="Path"></path>
                                                                    <path
                                                                        d="M13.9709883,21.6740977 L11.1720273,21.6740977 C10.7513555,21.6740977 10.4103086,22.0151445 10.4103086,22.4358164 C10.4103086,22.8564883 10.7513555,23.1975352 11.1720273,23.1975352 L13.9709883,23.1975352 C14.3916602,23.1975352 14.732707,22.8564883 14.732707,22.4358164 C14.732707,22.0151445 14.3916602,21.6740977 13.9709883,21.6740977 Z"
                                                                        id="Path"></path>
                                                                </g>
                                                            </g>
                                                        </g>
                                                    </g>
                                                </g>
                                            </svg>
                                            <span>
                                                {{ $translate("Froschkoenig::Template.singleDoc") }}
                                            </span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div class="single-rightside m-t-1">
                            <div class="single-rightside--inner">
                                <!-- START SINGLEITEM_DETAILS -->
                                <h1 class="h2 title single-rightside--1">{{ currentVariation | itemName }}</h1>

                                <div class="row single-rightside--2">
                                    <div class="col-12">
                                        <span class="price">
                                            <item-price :show-cross-price="isRecommendedPriceActive"></item-price>

                                            <div class="vat small">
                                                {{ $translate("Froschkoenig::Template.singleVat1") }} <span
                                                    class="vat--green">{{
                                                    $translate("Froschkoenig::Template.singleVat2") }}</span>
                                            </div>
                                        </span>
                                    </div>
                                    <div class="item-bottom">

                                        <div class="item-bottom__item item-bottom__item--share d-lg-none">
                                            <span><i class="fa fa-share-alt"></i>&nbsp;{{
                                                $translate("Froschkoenig::Template.singleSocial") }}</span>
                                            <div class="share-dd">
                                                <a href="https://www.facebook.com/froschkoenig24.de" target="_blank"><i
                                                        class="fab fa-facebook-square"></i> Facebook</a>
                                                <a href="https://www.instagram.com/froschkoenig_24_living/"
                                                    target="_blank"><i class="fab fa-instagram"></i> Instagram</a>
                                                <a href="https://www.youtube.com/channel/UC5GhTdbrQF_dMqcv2JNEapQ"
                                                    target="_blank"><i class="fab fa-youtube"></i> Youtube</a>
                                            </div>
                                        </div>
                                        <div class="item-bottom__item item-bottom__item--wishlist d-lg-none">
                                            <add-to-wish-list
                                                :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-6 mt-2 js--trustpilot-reviews"
                                        :class="{'trustpilot-reviews': trustpilotFound}"
                                        @click="toggleReviewsTab(); scrollToDescription(true)">
                                        <slot name="trustpilot-widget-small"></slot>
                                    </div>
                                    <div class="col-12 single__sharing-n-stuff">
                                        <div class="item-bottom__item item-bottom__item--share">
                                            <span><i
                                                    class="fa fa-share-alt"></i>&nbsp;{{$translate("Froschkoenig::Template.singleSocial")}}</span>
                                            <div class="share-dd">
                                                <a href="https://www.facebook.com/froschkoenig24.de" target="_blank"><i
                                                        class="fa fa-facebook-square"></i> Facebook</a>
                                                <a href="https://www.instagram.com/froschkoenig_24_living/"
                                                    target="_blank"><i class="fa fa-instagram"></i> Instagram</a>
                                                <a href="https://www.youtube.com/channel/UC5GhTdbrQF_dMqcv2JNEapQ"
                                                    target="_blank"><i class="fa fa-youtube"></i> Youtube</a>
                                            </div>
                                        </div>

                                        <div class="item-bottom__item item-bottom__item--wishlist">
                                            <add-to-wish-list
                                                :variation-id="currentVariation.variation.id"></add-to-wish-list>
                                        </div>

                                        <!--                                        &lt;!&ndash; Item Bundle &ndash;&gt;-->
                                        <!--                                        <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"-->
                                        <!--                                                     :bundle-type="currentVariation.variation.bundleType"-->
                                        <!--                                                     :bundle-components="currentVariation.bundleComponents"></item-bundle>-->
                                        <!--                                        &lt;!&ndash; /Item Bundle &ndash;&gt;-->
                                    </div>
                                    <!--                                    <div class="col-12 d-lg-none">-->
                                    <!--                                        <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"-->
                                    <!--                                                     :bundle-type="currentVariation.variation.bundleType"-->
                                    <!--                                                     :bundle-components="currentVariation.bundleComponents"></item-bundle>-->
                                    <!--                                    </div>-->
                                </div>

                                <div v-if="$store.state.viewport.isMobile"
                                    class="row single__variation-selection single-rightside--3">
                                    <div v-if="attributes.length || Object.keys(units).length"
                                        class="col-12 col-md-6 col-lg-12 single__variation-selection--zubehoer">
                                        <variation-select></variation-select>
                                    </div>

                                    <slot name="crosssellingsimilar"></slot>

                                    <hr>
                                </div>

                                <hr class="single-rightside--4">

                                <div class="row single-rightside--5">
                                    <div class="col-12 col-md-6 d-block d-md-none">
                                        <p class="single__stock" v-if="currentVariation.stock.net > 0">
                                            <span v-if="currentVariation.stock.net > 10">
                                                <span class="stock-indicator stock-indicator-green"></span>
                                                {{ $translate("Froschkoenig::Template.singleStockMoreThan10") }}
                                            </span>
                                            <span v-else>
                                                <span class="stock-indicator stock-indicator-red"></span>
                                                {{ $translate("Froschkoenig::Template.singleStockOnly1") }}
                                                {{ currentVariation.stock.net }} {{
                                                $translate("Froschkoenig::Template.singleStockOnly2") }}
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <div class="row single-rightside--6"
                                    v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                                    <order-property-list></order-property-list>
                                </div>

                                <graduated-prices></graduated-prices>

                                <div class="row single__article-info-container single-rightside--8">
                                    <div class="col-12 d-none d-md-block mb-3" v-if="currentVariation.stock.net > 0">
                                        <div v-if="currentVariation.stock.net > 10">
                                            <div class="stock-indicator stock-indicator-green"></div>
                                            {{ $translate("Froschkoenig::Template.singleStockMoreThan10") }}
                                        </div>
                                        <div v-else>
                                            <div class="stock-indicator stock-indicator-red"></div>
                                            {{ $translate("Froschkoenig::Template.singleStockOnly1") }} {{
                                            currentVariation.stock.net }} {{
                                            $translate("Froschkoenig::Template.singleStockOnly2") }}
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg-12 col-xl-9">
                                        <table class="table single__details-table">
                                            <tbody>
                                                <tr>
                                                    <td class="single__td-label">{{
                                                        $translate("Ceres::Template.singleItemNumber") }}
                                                    </td>
                                                    <td>{{ currentVariation.item.id }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="single__td-label">{{
                                                        $translate("Ceres::Template.singleItemDimensions") }}
                                                    </td>
                                                    <td>
                                                        <slot name="abmessungen"></slot>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="single__td-label">{{
                                                        $translate("Froschkoenig::Template.singleItemLieferzeit") }}
                                                    </td>
                                                    <td
                                                        :class="'single__availability-label-' + currentVariation.variation.availability.id">
                                                        {{ currentVariation.variation.availability.names.name }}
                                                    </td>
                                                </tr>
                                                <template v-if="varProps.length > 0">
                                                    <template v-for="prop in varProps">
                                                        <template v-if="prop.values.selectionId == 302">
                                                            <tr>
                                                                <td class="single__td-label">{{
                                                                    $translate("Froschkoenig::Template.singleShippingInfo")
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    <a class="shippinginfo-link shippinginfo-link--no-border"
                                                                        data-toggle="modal" href="#shippinginfo">
                                                                        {{
                                                                        $translate("Froschkoenig::Template.singleShippingInfoShow")
                                                                        }}
                                                                        <svg role="img" class="svg-icon__icon"
                                                                            focusable="false" viewBox="0 0 22 22"
                                                                            xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z">
                                                                            </path>
                                                                            <path
                                                                                d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z">
                                                                            </path>
                                                                        </svg>
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </template>
                                                </template>
                                                <tr class="toggle-hidden" :class="{'hidden': !showMore}"
                                                    v-if="currentVariation.variation.weightG > 0">
                                                    <td class="single__td-label">{{
                                                        $translate("Froschkoenig::Template.singleShippingWeight") }}
                                                    </td>
                                                    <td>{{ currentVariation.variation.weightG / 1000 }} kg</td>
                                                </tr>
                                                <tr class="toggle-hidden" :class="{'hidden': !showMore}">
                                                    <td class="single__td-label">{{
                                                        $translate("Froschkoenig::Template.singleShippingCondition") }}
                                                    </td>
                                                    <td>
                                                        <slot name="free6"></slot>
                                                    </td>
                                                </tr>
                                                <tr class="toggle-hidden" :class="{'hidden': !showMore}">
                                                    <td class="single__td-label">
                                                        {{
                                                        $translate("Froschkoenig::Template.singleShippingInfoDetails")
                                                        }}
                                                    </td>
                                                    <td>
                                                        <slot name="free5"></slot>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="single-rightside--9">
                                    <a @click.prevent="showMore = !showMore" href="#" class="single__more-details">{{
                                        $translate("Froschkoenig::Template.singleMoreInfo") }}&nbsp;<i
                                            class="fa  single__more-info-icon"
                                            :class="{'fa-chevron-down' : !showMore, 'fa-chevron-up': showMore }"></i></a>
                                </div>

                                <div class="single-rightside--10 d-flex justify-content-between flex-wrap">
                                    <template v-if="!hasPaketOrSpeditionProp">
                                        <template v-if="has304Prop">
                                            <a class="shippinginfo-link" data-toggle="modal"
                                                @click="injectPricesIntoModal()" href="#shippinginfo-304">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xlink:href="#spedition-no-text"></use>
                                                </svg>
                                                {{ $translate("Froschkoenig::Template.shippinginfoMontage") }}
                                                <svg role="img" class="svg-icon__icon" focusable="false"
                                                    viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z">
                                                    </path>
                                                    <path
                                                        d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z">
                                                    </path>
                                                </svg>
                                            </a>
                                        </template>
                                        <template v-else>
                                            <a class="shippinginfo-link" data-toggle="modal"
                                                @click="injectPricesIntoModal()" href="#shippinginfo-302">
                                                <svg xmlns="http://www.w3.org/2000/svg">
                                                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                                        xlink:href="#spedition-no-text"></use>
                                                </svg>
                                                {{ $translate("Froschkoenig::Template.shippinginfoSpedNoMontage") }}
                                                <svg role="img" class="svg-icon__icon" focusable="false"
                                                    viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z">
                                                    </path>
                                                    <path
                                                        d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z">
                                                    </path>
                                                </svg>
                                            </a>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <template v-for="prop in varProps">
                                            <template
                                                v-if="prop.values.selectionId == 302 || prop.values.selectionId == 303">
                                                <a class="shippinginfo-link" data-toggle="modal"
                                                    @click="injectPricesIntoModal()"
                                                    :href="hasShippingPrices ? '#shippinginfo-302-prices' : '#shippinginfo-302'">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            xlink:href="#spedition-no-text"></use>
                                                    </svg>
                                                    <template v-if="hasShippingPrices">{{
                                                        $translate("Froschkoenig::Template.shippinginfoSpedMontage")
                                                        }}</template>
                                                    <template v-else>{{
                                                        $translate("Froschkoenig::Template.shippinginfoSpedNoMontage")
                                                        }}</template>
                                                    <svg role="img" class="svg-icon__icon" focusable="false"
                                                        viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z">
                                                        </path>
                                                        <path
                                                            d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </template>
                                            <template v-else-if="prop.values.selectionId == 301">
                                                <a class="shippinginfo-link" data-toggle="modal"
                                                    @click="injectPricesIntoModal()"
                                                    :href="hasShippingPrices ? '#shippinginfo-301-prices' : '#shippinginfo-301'">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            xlink:href="#spedition-no-text"></use>
                                                    </svg>
                                                    <template v-if="hasShippingPrices">{{
                                                        $translate("Froschkoenig::Template.shippinginfoPaketMontage")
                                                        }}</template>
                                                    <template v-else>{{
                                                        $translate("Froschkoenig::Template.shippinginfoPaketNoMontage")
                                                        }}</template>
                                                    <svg role="img" class="svg-icon__icon" focusable="false"
                                                        viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z">
                                                        </path>
                                                        <path
                                                            d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </template>
                                            <template v-else-if="prop.values.selectionId == 304">
                                                <a class="shippinginfo-link" data-toggle="modal"
                                                    @click="injectPricesIntoModal()" href="#shippinginfo-304">
                                                    <svg xmlns="http://www.w3.org/2000/svg">
                                                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                                            xlink:href="#spedition-no-text"></use>
                                                    </svg>
                                                    {{ $translate("Froschkoenig::Template.shippinginfoMontage") }}
                                                    <svg role="img" class="svg-icon__icon" focusable="false"
                                                        viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M11 1.571c5.186 0 9.429 4.243 9.429 9.429S16.186 20.429 11 20.429 1.571 16.186 1.571 11 5.814 1.571 11 1.571zM11 0C4.95 0 0 4.95 0 11s4.95 11 11 11 11-4.95 11-11S17.05 0 11 0z">
                                                        </path>
                                                        <path
                                                            d="M10.214 16.5h1.572V9.429h-1.572V16.5zM11 7.857A1.179 1.179 0 1011 5.5a1.179 1.179 0 000 2.357z">
                                                        </path>
                                                    </svg>
                                                </a>
                                            </template>
                                        </template>
                                    </template>

                                    <a @click.prevent="scrollToDescription()" href="#"
                                        class="single__goto-description shippinginfo-link d-flex flex-wrap flex-lg-nowrap">
                                        {{ $translate("Froschkoenig::Template.singleGotoDescription") }}
                                    </a>
                                </div>

                                <hr class="single-rightside--11">

                                <div class="d-none single-rightside--12">
                                    <slot name="variationimage"></slot>
                                </div>
                                <div v-if="!($store.state.viewport.isMobile)"
                                    class="row single__variation-selection single-rightside--13">
                                    <div v-if="attributes.length || Object.keys(units).length"
                                        class="col-12 col-md-6 col-lg-12 single__variation-selection--zubehoer">
                                        <variation-select></variation-select>
                                    </div>

                                    <slot name="crosssellingsimilar"></slot>

                                    <hr>
                                </div>

                                <hr v-if="!($store.state.viewport.isMobile)" class="single-rightside--14">

                                <!--                                <a class="btn btn-secondary btn-shipping-single" data-toggle="modal" href="#shippingscosts" :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate('Ceres::Template.singleItemShippingCosts') }}</a>-->

                                <div class="row m-y-1 single__add-to-basket-row single-rightside--16">
                                    <add-to-basket :variation-id="currentVariation.variation.id"
                                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                        :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                        :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                        :use-large-scale="false" :show-quantity="true"
                                        :item-url="currentVariation | itemURL"
                                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                        :has-price="currentVariation | hasItemDefaultPrice">
                                    </add-to-basket>
                                </div>

                                <slot name="before-add-to-basket"></slot>
                                <slot name="after-add-to-basket"></slot>

                                <slot name="after-price"></slot>

                                <a ref="scroll" href="#" class="single__get-offer single-rightside--17">
                                    <svg width="30px" height="25px">
                                        <use xlink:href="#svg_offer" xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                    </svg>
                                    {{ $translate("Froschkoenig::Template.singleGetOffer") }}</a>

                                <ul class="payment-icons single-rightside--18">
                                    <li class="payment-icons__item">
                                        <svg class="payment-icons__svg">
                                            <use xlink:href="#paypal-single"
                                                xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </li>
                                    <li class="payment-icons__item">
                                        <svg class="payment-icons__svg">
                                            <use xlink:href="#vorkasse-single"
                                                xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </li>
                                    <li class="payment-icons__item">
                                        <svg class="payment-icons__svg">
                                            <use xlink:href="#lastschrift-single"
                                                xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </li>
                                    <li class="payment-icons__item">
                                        <svg class="payment-icons__svg">
                                            <use xlink:href="#sofort-single"
                                                xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                        </svg>
                                    </li>
                                    <li class="payment-icons__item payment-icons__item--spacing">
                                        <svg width="81" height="20" viewBox="0 0 81 20">
                                            <g transform="translate(0, 0) scale(1)">
                                                <path class="fill"
                                                    d="M78.3352549,14.3292706 C77.0678017,14.3292706 76.0403439,15.3567284 76.0403439,16.6243597 C76.0403439,17.8916348 77.0678017,18.9192707 78.3352549,18.9192707 C79.6027081,18.9192707 80.630344,17.8916348 80.630344,16.6243597 C80.630344,15.3567284 79.6027081,14.3292706 78.3352549,14.3292706"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                                <path class="fill"
                                                    d="M70.7958568,7.22817345 L70.7958568,6.4467803 L74.4529833,6.4467803 L74.4529833,18.6618356 L70.7958568,18.6618356 L70.7958568,17.8811547 C69.7626656,18.5857975 68.5156063,19 67.1704277,19 C63.6107082,19 60.7250027,16.1142945 60.7250027,12.554575 C60.7250027,8.99485561 63.6107082,6.10915009 67.1704277,6.10915009 C68.5156063,6.10915009 69.7626656,6.52335256 70.7958568,7.22817345 Z M67.4697718,15.6974209 C69.3000267,15.6974209 70.7835696,14.2902722 70.7835696,12.554575 C70.7835696,10.8188779 69.3000267,9.41208536 67.4697718,9.41208536 C65.6395168,9.41208536 64.1559739,10.8188779 64.1559739,12.554575 C64.1559739,14.2902722 65.6395168,15.6974209 67.4697718,15.6974209 Z"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                                <path class="fill"
                                                    d="M54.2263333,6.11823191 C52.765406,6.11823191 51.3828316,6.57178896 50.4584442,7.82312205 L50.4584442,6.4474926 L46.8169884,6.4474926 L46.8169884,18.6618356 L50.503141,18.6618356 L50.503141,12.2427657 C50.503141,10.3852653 51.7487757,9.47565814 53.2485235,9.47565814 C54.8558285,9.47565814 55.7798597,10.4358386 55.7798597,12.2174791 L55.7798597,18.6618356 L59.4327124,18.6618356 L59.4327124,10.8940256 C59.4327124,8.05141421 57.1725844,6.11823191 54.2263333,6.11823191"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                                <path class="fill"
                                                    d="M41.5278044,8.03788051 L41.5278044,6.44695838 L37.7834212,6.44695838 L37.7834212,18.6618356 L41.536174,18.6618356 L41.536174,12.9588053 C41.536174,11.0347048 43.6216104,10.0004452 45.0686479,10.0004452 C45.0834281,10.0004452 45.097318,10.0018698 45.1120982,10.0020479 L45.1120982,6.44767068 C43.6269526,6.44767068 42.2609392,7.08357654 41.5278044,8.03788051"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                                <path class="fill"
                                                    d="M32.2128788,7.22817345 L32.2128788,6.4467803 L35.8701833,6.4467803 L35.8701833,18.6618356 L32.2128788,18.6618356 L32.2128788,17.8811547 C31.1796876,18.5857975 29.9326283,19 28.5876277,19 C25.0279083,19 22.1422028,16.1142945 22.1422028,12.554575 C22.1422028,8.99485561 25.0279083,6.10915009 28.5876277,6.10915009 C29.9326283,6.10915009 31.1796876,6.52335256 32.2128788,7.22817345 Z M28.8867938,15.6974209 C30.7170487,15.6974209 32.2007697,14.2902722 32.2007697,12.554575 C32.2007697,10.8188779 30.7170487,9.41208536 28.8867938,9.41208536 C27.0567169,9.41208536 25.5729959,10.8188779 25.5729959,12.554575 C25.5729959,14.2902722 27.0567169,15.6974209 28.8867938,15.6974209 Z"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                                <path class="fill"
                                                    d="M16.8150889 18.6618356 20.6429893 18.6618356 20.6429893 1.00338343 16.8150889 1.00338343z"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                                <path class="fill"
                                                    d="M14.1770857,1 L10.2104649,1 C10.2104649,4.25111544 8.71570325,7.23511837 6.10957549,9.1873547 L4.53806353,10.3642524 L10.6271604,18.6673559 L15.6335612,18.6673559 L10.0307872,11.0272257 C12.6865979,8.38263373 14.1770857,4.82469505 14.1770857,1"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                                <path class="fill"
                                                    d="M0 18.6666436 4.05334336 18.6666436 4.05334336 1 0 1z"
                                                    fill="rgba(23, 18, 15, 1)"></path>
                                            </g>
                                        </svg>
                                    </li>
                                    <li class="payment-icons__item payment-icons__item--spacing">
                                        <div class="payment-bg">
                                            <img class="lazy-img payment-icons__img"
                                                :data-src="pluginPath + '/images/easycredit_neu.png'"
                                                :data-srcset="pluginPath + '/images/easycredit_neu.png'"
                                                alt="easyCredit">
                                        </div>
                                    </li>
                                    <li class="payment-icons__item">
                                        <img class="lazy-img img-br payment-icons__img"
                                            :data-src="pluginPath + '/images/barzahlung.jpg'"
                                            :data-srcset="pluginPath + '/images/barzahlung.jpg'" alt="Barzahlung">
                                    </li>
                                </ul>

                                <slot name="before-price"></slot>

                                <slot name="additional-content-after-add-to-basket"></slot>

                                <slot name="additional-content-after-VAT"></slot>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="single__crossselling-tabs"
                    v-if="crosssellinglist1.length > 0 || crosssellinglist2.length > 0 || currentVariation.variation.bundleType === 'bundle'">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" v-if="crosssellinglist1.length > 0">
                            <a class="nav-link active" id="crossseller-1-tab" data-toggle="tab" href="#crossseller-1"
                                role="tab" aria-controls="home" aria-selected="true">
                                {{ $translate("Froschkoenig::Template.singleCrossseller1Headline") }}
                            </a>
                        </li>
                        <li class="nav-item" :class="{'active': crosssellinglist1.length === 0}"
                            v-if="crosssellinglist2.length > 0">
                            <a class="nav-link" id="crossseller-2-tab" data-toggle="tab" href="#crossseller-2"
                                role="tab" aria-controls="profile" aria-selected="false">
                                {{ $translate("Froschkoenig::Template.singleCrossseller2Headline") }}
                            </a>
                        </li>
                        <li class="nav-item"
                            :class="{'active': crosssellinglist1.length === 0 && crosssellinglist2.length === 0}"
                            v-if="currentVariation.variation.bundleType === 'bundle'">
                            <a class="nav-link" id="set-items-tab" data-toggle="tab" href="#set-items" role="tab"
                                aria-controls="profile" aria-selected="false">
                                {{ $translate("Froschkoenig::Template.singleSetContent") }}
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                        <div class="tab-pane fade show active" id="crossseller-1" role="tabpanel"
                            aria-labelledby="crossseller-1-tab" v-if="crosssellinglist1.length > 0">
                            <slot name="crosssellinglist1"></slot>
                        </div>
                        <div class="tab-pane fade" :class="{'show active': crosssellinglist1.length === 0}"
                            v-if="crosssellinglist2.length > 0" id="crossseller-2" role="tabpanel"
                            aria-labelledby="crossseller-2-tab">
                            <slot name="crosssellinglist2"></slot>
                        </div>
                        <div class="tab-pane fade" :class="{'show active': crosssellinglist1.length === 0}"
                            v-if="currentVariation.variation.bundleType === 'bundle'" id="set-items" role="tabpanel"
                            aria-labelledby="set-items-tab">
                            <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                                :bundle-type="currentVariation.variation.bundleType"
                                :bundle-components="currentVariation.bundleComponents" :in-tab="true" />
                        </div>
                    </div>
                </div>



                <slot name="usp"></slot>

                <!-- END -->

                <div class="single__shortdescription">
                    <div class="single-description__wrapper" v-if="currentVariation.texts.shortDescription !== ''">
                        <p class="single-description__headline">{{
                            $translate("Froschkoenig::Template.singleShortDescription") }}</p>
                        <client-only>
                            <p class="single-description" v-html="currentVariation.texts.shortDescription"></p>
                        </client-only>
                        <a href="#" class="js--single-description__more text-more"
                            v-if="currentVariation.texts.shortDescription !== ''">{{
                            $translate("Froschkoenig::Template.singleShortDescriptionShowMore") }}&nbsp;<i
                                class="fa fa-chevron-down"></i></a>
                    </div>

                    <slot name="shortdesc"></slot>

                </div>

                <div class="m-y-3 single__description">
                    <!-- ITEM DESCRIPTION -->
                    <div class="my-5">
                        <ul class="nav nav-tabs nav nav-tabs d-none d-lg-flex" role="tablist">
                            <li class="nav-item" v-if="isDescriptionTabActive">
                                <a class="nav-link active" data-toggle="tab"
                                    :href="'#details-' + currentVariation.variation.id" role="tab">{{
                                    $translate("Ceres::Template.singleItemDescription") }}</a>
                            </li>

                            <li class="nav-item" v-if="isTechnicalDataTabActive">
                                <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                    class="nav-link" data-toggle="tab" :href="'#data-' + currentVariation.variation.id"
                                    role="tab">{{ $translate("Froschkoenig::Template.singleTabsProperties") }}</a>
                            </li>

                            <li class="nav-item"
                                @mouseover.once="$store.dispatch('loadComponent', 'item-service-versand')">
                                <a href="#service-versand" class="nav-link" data-toggle="tab" role="tab">{{
                                    $translate("Froschkoenig::Template.singleTabsService") }}<i
                                        class="fa fa-chevron-down"></i></a>
                            </li>

                            <li class="nav-item"
                                @mouseover.once="$store.dispatch('loadComponent', 'item-zahlungsarten')">
                                <a href="#zahlungsarten" class="nav-link" data-toggle="tab" role="tab">{{
                                    $translate("Froschkoenig::Template.singleTabsPayments") }}<i
                                        class="fa fa-chevron-down"></i></a>
                            </li>

                            <li class="nav-item">
                                <a href="#bewertung" class="nav-link js--reviews-tab" data-toggle="tab" role="tab">{{
                                    $translate("Froschkoenig::Template.singleTabsReviews") }}<i
                                        class="fa fa-chevron-down"></i></a>
                            </li>

                            <li class="nav-item">
                                <a href="#contact" class="nav-link" data-toggle="tab" role="tab">{{
                                    $translate("Froschkoenig::Template.singleTabsContact") }}<i
                                        class="fa fa-chevron-down"></i></a>
                            </li>

                            <slot name="add-detail-tabs"></slot>
                        </ul>

                        <div class="tab-content overflow-hidden">

                            <ul class="nav nav-tabs d-block d-lg-none " role="tablist">
                                <li class="nav-item" v-if="isDescriptionTabActive">
                                    <a class="nav-link active nav-link--inner" data-toggle="tab"
                                        :href="'#details-' +  currentVariation.variation.id" role="tab">{{
                                        $translate("Ceres::Template.singleItemDescription") }}<i
                                            class="fa fa-chevron-down"></i></a>
                                </li>
                            </ul>

                            <div class="tab-pane active tab-description"
                                :id="'details-' + currentVariation.variation.id" role="tabpanel"
                                v-if="isDescriptionTabActive">
                                <slot class="my-4" name="ratgeber"></slot>

                                <div class="my-4">
                                    <h3 class="description__title h1">{{
                                        $translate("Froschkoenig::Template.descriptionFor") }} {{ currentVariation |
                                        itemName }}</h3>
                                    <client-only>
                                        <div ref="description" v-html="currentVariation.texts.description"></div>
                                    </client-only>
                                </div>

                                <div class="single__links-with-img">
                                    <div v-if="getVarPropForImageLink('Material', 'image') !== ''"
                                        class="single__links-with-img-wrapper">
                                        <a :href="getVarPropForImageLink('Material', 'link')">
                                            <lazy-img picture-class="single__links-with-img-image"
                                                :image-url="getVarPropForImageLink('Material', 'image')" alt="Material"
                                                title="Material">
                                            </lazy-img>
                                            <div class="single__links-with-img-text"
                                                v-html="getVarPropForImageLink('Material', 'text')">
                                            </div>
                                        </a>
                                    </div>

                                    <div v-if="getVarPropForImageLink('Oberfläche', 'image') !== ''"
                                        class="single__links-with-img-wrapper">
                                        <a :href="getVarPropForImageLink('Oberfläche', 'link')">
                                            <lazy-img picture-class="single__links-with-img-image"
                                                :image-url="getVarPropForImageLink('Oberfläche', 'image')"
                                                alt="Oberfläche" title="Oberfläche">
                                            </lazy-img>
                                            <div class="single__links-with-img-text"
                                                v-html="getVarPropForImageLink('Oberfläche', 'text')">
                                            </div>
                                        </a>
                                    </div>

                                    <div v-if="getVarPropForImageLink('Hersteller', 'image') !== ''"
                                        class="single__links-with-img-wrapper">
                                        <a :href="getVarPropForImageLink('Hersteller', 'link')">
                                            <lazy-img
                                                picture-class="single__links-with-img-image single__links-with-img-image--brand"
                                                :image-url="getVarPropForImageLink('Hersteller', 'image')"
                                                alt="Hersteller" title="Hersteller">
                                            </lazy-img>
                                        </a>
                                    </div>
                                </div>
                                <div class="single__open-product-details"
                                    v-if="currentVariation.texts.technicalData != ''">
                                    <button class="btn btn-primary">
                                        {{ $translate("Froschkoenig::Template.singleTabsMoreInfo") }}
                                    </button>
                                </div>
                                <client-only>
                                    <div class="item-technical clearfix" v-html="currentVariation.texts.technicalData">
                                    </div>
                                </client-only>
                                <div class="item-contact">
                                    <div class="item-contact__item item-contact__item--anfrage">
                                        <p>{{ $translate("Froschkoenig::Template.singleTeamTeaser") }}</p>
                                        <a href="#" class="btn btn-default btn-block item-contact__trigger-form">{{
                                            $translate("Froschkoenig::Template.singleTeamContact") }}</a>
                                    </div>
                                    <div class="item-contact__item item-contact__item--links">
                                        <a class="item-contact__item-link" href="mailto:info@froschkoenig24.com"
                                            title="E-Mail senden">
                                            <svg class="svg_item-mail">
                                                <use xlink:href="#svg_item-mail"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            info@froschkoenig24.com</a>
                                        <a class="item-contact__item-link" href="tel:+498709263439" title="anrufen">
                                            <svg class="svg_item-phone">
                                                <use xlink:href="#svg_item-phone"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            Tel: 08709 26 34 39</a>
                                    </div>
                                    <div class="item-contact__item item-contact__item--open">
                                        <div>
                                            <p class="font-weight-bold">{{
                                                $translate("Froschkoenig::Template.singleContactMoDo") }}</p>
                                            <p>{{ $translate("Froschkoenig::Template.singleContactMoDoTime") }}</p>
                                        </div>
                                        <div>
                                            <p class="font-weight-bold">{{
                                                $translate("Froschkoenig::Template.singleContactFr") }}</p>
                                            <p>{{ $translate("Froschkoenig::Template.singleContactFrTime") }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ul class="nav nav-tabs d-block d-lg-none" role="tablist">
                                <li class="nav-item">
                                    <a :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                        class="nav-link nav-link--inner" data-toggle="tab"
                                        :href="'#data-' + currentVariation.variation.id" role="tab">{{
                                        $translate("Ceres::Template.singleItemTechnicalData") }}<i
                                            class="fa fa-chevron-down"></i></a>
                                </li>
                            </ul>

                            <div :class="{ 'active': !isDescriptionTabActive && isTechnicalDataTabActive }"
                                class="tab-pane overflow-auto" :id="'data-' + currentVariation.variation.id"
                                role="tabpanel" v-if="isTechnicalDataTabActive">
                                <div class="my-4">
                                    <table class="table table-striped table-hover table-sm">
                                        <tbody>
                                            <tr v-if="itemConfig.includes('item.id') || itemConfig.includes('all')">
                                                <td>{{ $translate("Ceres::Template.singleItemId") }}</td>
                                                <td>{{ currentVariation.item.id }}</td>
                                            </tr>

                                            <tr
                                                v-if="currentVariation.variation.model !== '' && (itemConfig.includes('item.variation_model') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemModel") }}</td>
                                                <td>{{ currentVariation.variation.model }}</td>
                                            </tr>

                                            <tr
                                                v-if="currentVariation.variation.weightG !== '' && (itemConfig.includes('item.weightG') || itemConfig.includes('all'))">
                                                <td>{{ $translate("Ceres::Template.singleItemWeight") }}</td>
                                                <td>{{ currentVariation.variation.weightG }} g</td>
                                            </tr>

                                            <tr
                                                v-if="itemConfig.includes('item.variation_dimensions') || itemConfig.includes('all')">
                                                <td>{{ $translate("Ceres::Template.singleItemDimensions") }}</td>
                                                <td>
                                                    <span>{{ currentVariation.variation.lengthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.widthMM }}</span>&times;<!--
                                                --><span>{{ currentVariation.variation.heightMM }}</span> mm
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <ul class="nav nav-tabs d-block d-lg-none" role="tablist">
                                <li class="nav-item">
                                    <a href="#service-versand"
                                        @mouseover.once="$store.dispatch('loadComponent', 'item-service-versand')"
                                        class="nav-link nav-link--inner" data-toggle="tab" role="tab">{{
                                        $translate("Froschkoenig::Template.singleTabsService") }}<i
                                            class="fa fa-chevron-down"></i></a>
                                </li>
                            </ul>
                            <div class="tab-pane" role="tabpanel" id="service-versand">
                                <lazy-load component="item-service-versand">
                                    <slot name="versand"></slot>
                                </lazy-load>
                            </div>

                            <ul class="nav nav-tabs d-block d-lg-none" role="tablist">
                                <li class="nav-item">
                                    <a href="#zahlungsarten"
                                        @mouseover.once="$store.dispatch('loadComponent', 'item-zahlungsarten')"
                                        class="nav-link nav-link--inner" data-toggle="tab" role="tab">{{
                                        $translate("Froschkoenig::Template.singleTabsPayments") }}<i
                                            class="fa fa-chevron-down"></i></a>
                                </li>
                            </ul>
                            <div class="tab-pane" role="tabpanel" id="zahlungsarten">
                                <lazy-load component="item-zahlungsarten">
                                    <slot name="payments"></slot>
                                </lazy-load>
                            </div>

                            <ul class="nav nav-tabs d-block d-lg-none" role="tablist">
                                <li class="nav-item">
                                    <a href="#bewertung" class="nav-link nav-link--inner js--reviews-tab"
                                        data-toggle="tab" role="tab">{{
                                        $translate("Froschkoenig::Template.singleTabsReviews") }}<i
                                            class="fa fa-chevron-down"></i></a>
                                </li>
                            </ul>
                            <div class="tab-pane" role="tabpanel" id="bewertung">

                                <slot name="FeedbackContainer"></slot>

                                <div class="d-none">

                                    <div class="stars js-stars">

                                        <input id="star-1" type="radio" value="1" name="ratingValue" class="star star-1"
                                            data-com.onepassword.iv="1">
                                        <label for="star-1" class="star star-1">
                                            <svg width="14" height="13" class="star-grey">
                                                <use xlink:href="#svg_star-grey"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            <svg width="14" height="13" class="star-orange d-none">
                                                <use xlink:href="#svg_star-orange"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </label>

                                        <input id="star-2" type="radio" value="2" name="ratingValue" class="star star-2"
                                            data-com.onepassword.iv="2">
                                        <label for="star-2" class="star star-2">
                                            <svg width="14" height="13" class="star-grey">
                                                <use xlink:href="#svg_star-grey"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            <svg width="14" height="13" class="star-orange d-none">
                                                <use xlink:href="#svg_star-orange"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </label>

                                        <input id="star-3" type="radio" value="3" name="ratingValue" class="star star-3"
                                            data-com.onepassword.iv="3">
                                        <label for="star-3" class="star star-3">
                                            <svg width="14" height="13" class="star-grey">
                                                <use xlink:href="#svg_star-grey"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            <svg width="14" height="13" class="star-orange d-none">
                                                <use xlink:href="#svg_star-orange"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </label>

                                        <input id="star-4" type="radio" value="4" name="ratingValue" class="star star-4"
                                            data-com.onepassword.iv="4">
                                        <label for="star-4" class="star star-4">
                                            <svg width="14" height="13" class="star-grey">
                                                <use xlink:href="#svg_star-grey"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            <svg width="14" height="13" class="star-orange d-none">
                                                <use xlink:href="#svg_star-orange"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </label>

                                        <input id="star-5" type="radio" value="5" name="ratingValue" class="star star-5"
                                            data-com.onepassword.iv="5">
                                        <label for="star-5" class="star star-5">
                                            <svg width="14" height="13" class="star-grey">
                                                <use xlink:href="#svg_star-grey"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                            <svg width="14" height="13" class="star-orange d-none">
                                                <use xlink:href="#svg_star-orange"
                                                    xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                                            </svg>
                                        </label>

                                    </div>

                                </div>

                                <slot name="trustpilot-widget"></slot>

                            </div>

                            <ul class="nav nav-tabs d-block d-lg-none" role="tablist">
                                <li class="nav-item">
                                    <a href="#contact" class="nav-link nav-link--inner" data-toggle="tab" role="tab">{{
                                        $translate("Froschkoenig::Template.singleTabsContact") }}<i
                                            class="fa fa-chevron-down"></i></a>
                                </li>
                            </ul>
                            <div class="tab-pane" role="tabpanel" id="contact">

                                <div class="cmp-contact">
                                    <div class="row">
                                        <div class="col-12 col-lg-9">
                                            <p class="contact-headline">{{ $translate("Ceres::Template.contact") }}</p>
                                            <p class="m-b-3">
                                                {{ $translate("Ceres::Template.contactShopMessage") }}
                                            </p>

                                            <div class="row">
                                                <div class="col-12 p-x-0 well well-sm">
                                                    <slot name="contactform"></slot>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <slot name="add-detail-tabs-content"></slot>
                        </div>
                        <!-- ./ITEM DESCRIPTION -->
                    </div>

                </div>

                <!--<slot name="item-list-container"></slot>
                <slot name="feedback-container"></slot>-->

                <slot name="crosssellinglowerlist"></slot>

                <div class="scroll-to-basket" @click="scrollToBasket()">
                    <i class="fa fa-arrow-up" aria-hidden="true"></i>
                    <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                </div>
            </div>
        </slot>
    </div>
</template>

<script>
import {get} from "ceres/app/helper/get";
import {isNullOrUndefined} from "ceres/app/helper/utils";
import {Swiper} from 'swiper';
import {serializeForm, getLabel} from "ceres/app/helper/serializeForm";

const NotificationService = require("ceres/app/services/NotificationService");

export default {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object,

		crosssellinglist1: Array,
		crosssellinglist2: Array,
    },

    data() {
        return {
            isMobile: false,
            isOpen: false,
            showMore: false,
            trustpilotFound: false,
            videoContent: 0,
        }
    },

    provide() {
        return {
            itemId: this.$props.itemId
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    computed:
        {
			hasVideo1(){
				return this.currentVariation.item.free3 !== '' && this.currentVariation.item.free3 !== '0' && this.currentVariation.item.free3 !== null
			},
			hasVideo2(){
				return this.currentVariation.item.free14 !== '' && this.currentVariation.item.free14 !== '0' && this.currentVariation.item.free14 !== null
			},
			hasDoc1(){
				return this.currentVariation.item.free1 !== '' && this.currentVariation.item.free1 !== '0' && this.currentVariation.item.free1 !== null
			},
			hasDoc2(){
				return this.currentVariation.item.free2 !== '' && this.currentVariation.item.free2 !== '0' && this.currentVariation.item.free2 !== null
			},


			hasDeliveryProps() {
                let hasDeliveryProps = false;

                const deliveryPropIds = [70, 71, 72];
                for (let key in this.currentVariation.variationProperties) {
                    for (let innerKey in this.currentVariation.variationProperties[key].properties) {
                        if(deliveryPropIds.includes(this.currentVariation.variationProperties[key].properties[innerKey].id)){
                            hasDeliveryProps = true;
                            break;
                        }
                    }
                }

                return hasDeliveryProps;
            },

            hasDeliveryProp72(){
                let hasDeliveryProp72 = false;

                const deliveryPropIds = [72];
                for (let key in this.currentVariation.variationProperties) {
                    for (let innerKey in this.currentVariation.variationProperties[key].properties) {
                        if(deliveryPropIds.includes(this.currentVariation.variationProperties[key].properties[innerKey].id)){
                            hasDeliveryProp72 = true;
                            break;
                        }
                    }
                }

                return hasDeliveryProp72;
            },

            pluginPath() {
                return App.pluginPath;
            },
            itemConfig() {
                return App.config.item.itemData;
            },

            isDescriptionTabActive() {
                return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all"))
                    && !!this.currentVariation.texts.description.length;
            },

            isRecommendedPriceActive() {
                return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
            },

            isShortDescriptionActive() {
                return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
            },

            hasShippingCostsCategoryId() {
                return App.config.global.shippingCostsCategoryId > 0;
            },

            hasShippingPrices(){
                let hasProps = false;
                for(let key in this.varProps){
                    if([70, 71, 72].includes(this.varProps[key].id)){
                        hasProps = true;
                        break;
                    }
                }
                return hasProps;
            },

            hasPaketOrSpeditionProp(){
                let hasProp = false;
                for(let key in this.varProps){
                    if([302, 301].includes(this.varProps[key].values.selectionId)){
                        hasProp = true;
                        break;
                    }
                }
                return hasProp;
            },

            has304Prop(){
                let hasProp = false;
                for(let key in this.varProps){
                    if([304].includes(this.varProps[key].values.selectionId)){
                        hasProp = true;
                        break;
                    }
                }
                return hasProp;
            },

            varProps() {
                let propArr = [];
                for (let key in this.currentVariation.variationProperties) {
                    for (let innerKey in this.currentVariation.variationProperties[key].properties) {
                        propArr.push(this.currentVariation.variationProperties[key].properties[innerKey]);
                    }
                }

                return propArr;
            },

            varPropsForImageLink(){
                for(let key in this.currentVariation.variationProperties){
                    if(this.currentVariation.variationProperties[key].id === 5){
                        for(let innerKey in this.currentVariation.variationProperties[key].properties){

                        }
                    }
                }
            },

            varPropsForHrefLink(){

            },

            isTechnicalDataTabActive() {
                return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all"))
                    && !!this.currentVariation.texts.technicalData.length;
            },

            variationGroupedProperties() {
                return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
            },

            variationMissingProperties() {
                return this.$store.getters[`${this.itemId}/variationMissingProperties`];
            },

            currentVariation() {
                return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
            },

            isVariationSelected() {
                return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
            },

            attributes() {
                return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
            },

            units() {
                return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
            },

            isItemSet() {
                return this.$store.state.items.isItemSet;
            }
        },

    created() {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
    },

    mounted() {
        let img = document.querySelectorAll('.single__description .tab-content img');
        for (let i = 0; i < img.length; i++) {
            let images = img[i];
            images.setAttribute('loading', 'lazy');
        }
        
        this.isMobile = window.innerWidth < 768

        this.$nextTick(() => {
            this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

            this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
                itemId: this.itemId,
                attributes: this.attributesData,
                variations: this.variations,
                initialVariationId: this.currentVariation.variation.id,
                isPleaseSelectOption: this.initPleaseSelectOption,
                afterKey: this.afterKey
            });

            if (this.isItemSet) {
                this.$store.dispatch("initSetComponents", this.itemData);
            }

            this.initSpecials();
        });

        let trustpilotTries = 0
        let interval = setInterval(() => {
            if(document.querySelector(".js--trustpilot-reviews iframe + iframe") !== null){
                this.trustpilotFound = true;
            }
            if(this.trustpilotFound || trustpilotTries >= 5){
                clearInterval(interval);
            }
            trustpilotTries++;
        }, 1000)
    },

    methods:
        {

            toggleModal(attr){
              $('#single-video').modal('show');
              this.videoContent = attr;
            },

            scrollToDescription(trustpilot){
                if((trustpilot === true && this.trustpilotFound) || trustpilot !== true){
                    const element = document.querySelector(".single__description");
                    element.scrollIntoView({block: "start", behavior: "smooth"});
                }
            },

            toggleReviewsTab(){
                if(this.trustpilotFound){
                    $(".js--reviews-tab").tab("show");
                }
            },

            getVarPropForImageLink(propType, displayType){
                // displayType: link, image or text
                // propType: hersteller, oberfläche, material

                let returnValue = "";
                for(let key in this.currentVariation.variationProperties){
                    if(this.currentVariation.variationProperties[key].id === 5){
                        if(propType === "Hersteller" && displayType === "link"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 84)
                        }else if(propType === "Hersteller" && displayType === "image"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 83)
                        }else if(propType === "Oberfläche" && displayType === "link"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 82)
                        }else if(propType === "Oberfläche" && displayType === "image"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 81)
                        }else if(propType === "Material" && displayType === "link"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 80)
                        }else if(propType === "Material" && displayType === "image"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 79)
                        }else if(propType === "Oberfläche" && displayType === "text"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 85)
                        }else if(propType === "Material" && displayType === "text"){
                            returnValue = this.currentVariation.variationProperties[key].properties.find(prop => prop.id === 86)
                        }
                    }
                }

				if(!isNullOrUndefined(returnValue.values)){
					return returnValue.values.value;
				}
				return returnValue;
            },

			scrollToBasket(){

				let element = this.$refs.scroll;

				let yPosition = 0;

				while(element) {
					yPosition += (element.offsetTop - element.scrollTop + element.clientTop);
					element = element.offsetParent;
				}

				window.scrollTo({
					top: yPosition - window.innerHeight + 50,
					left: 0,
					behavior: 'smooth'
				});
			},

            getVarPropShippingValue(typeId){
                let value = "";
                for(let key in this.varProps){
                    if(typeId === this.varProps[key].id){
                        value = this.varProps[key].values.value;
                        break;
                    }
                }

                return parseFloat(value);
            },

            injectPricesIntoModal() {
                // get AT shipping costs
                let itemPrice = this.currentVariation.prices.default.price.value;
                let atShippingPrice = 0;

                if (itemPrice > 1500) {
                    atShippingPrice = 149;
                } else if (itemPrice > 500 && itemPrice <= 1500) {
                    atShippingPrice = 99;
                } else if (itemPrice > 300 && itemPrice <= 500) {
                    atShippingPrice = 49;
                } else if (itemPrice > 150 && itemPrice <= 300) {
                    atShippingPrice = 29;
                } else {
                    atShippingPrice = 15;
                }

                if (this.has304Prop || this.hasDeliveryProp72) {
                    atShippingPrice = parseFloat(App.atbasepriceMontage);
                }

                if (document.getElementsByClassName('shippinginfo__receive-at-base').length) {
                    const atBases = document.getElementsByClassName('shippinginfo__receive-at-base');
                    for (let key in atBases) {
                        if (atBases.hasOwnProperty(key)) {
                            atBases[key].innerHTML = atShippingPrice + " €";
                        }
                    }
                }

                if (!!document.querySelector('.shippinginfo__receive-70')) {
                    const r70er = document.getElementsByClassName('shippinginfo__receive-70');
                    for (let key in r70er) {
                        if (r70er.hasOwnProperty(key)) {
                            r70er[key].innerHTML = this.getVarPropShippingValue(70) + " €";
                        }
                    }
                }
                if (!!document.querySelector('.shippinginfo__receive-70-at')) {
                    const r70er = document.getElementsByClassName('shippinginfo__receive-70-at');
                    for (let key in r70er) {
                        if (r70er.hasOwnProperty(key)) {
                            r70er[key].innerHTML = (this.getVarPropShippingValue(70) + 50) + " €";
                        }
                    }
                }
                if (!!document.querySelector('.shippinginfo__receive-72')) {
                    const r72er = document.getElementsByClassName('shippinginfo__receive-72');
                    for (let key in r72er) {
                        if (r72er.hasOwnProperty(key)) {
                            r72er[key].innerHTML = this.getVarPropShippingValue(72) + " €";
                        }
                    }
                }
                if (!!document.querySelector('.shippinginfo__receive-72-at')) {
                    const r72er = document.getElementsByClassName('shippinginfo__receive-72-at');
                    for (let key in r72er) {
                        if (r72er.hasOwnProperty(key)) {
                            r72er[key].innerHTML = (this.getVarPropShippingValue(72) + 50) + " €";
                        }
                    }
                }
            },

            createDescription() {
                $(this.$refs['description']).find('.itemDefList').prepend('<img loading="lazy" class="description-image" src="' + this.currentVariation.images.all[0].urlPreview + '" alt="' + this.$options.filters.itemName(this.currentVariation) + '">');
            },

            imgLoaded(imgElement) {
                return imgElement.complete && imgElement.naturalHeight !== 0;
            },

            initSpecials() {
                let that = this;

                setTimeout(function () {
                    that.createDescription();

                    if ($("#single__parent-cat-id").length) {
                        $("#page-body").addClass("category-" + $("#single__parent-cat-id").text());
                        $(".category__frosch").addClass("category__frosch--id-" + $("#single__parent-cat-id").text());
                    }

                    if ($(".single-variations-swiper").length) {

                        var swipeVariations = new Swiper(".single-variations-swiper", {
                            navigation: {
                                nextEl: '.swiper-button-next-variations',
                                prevEl: '.swiper-button-prev-variations',
                            },
                            spaceBetween: 5,
                            loop: false,
                            slidesPerView: 3,
                            centeredSlides: false,
                            breakpointsInverse: true,
                            breakpoints: {
                                991: {
                                    allowTouchMove: false,
                                    slidesPerView: 4
                                }
                            }
                        });
                    }

                    function myTimer2() {
                        if ($('.single-swiper').length && $('.single-swiper .swiper-slide:first-child img').length) {
                            if (that.imgLoaded($('.single-swiper .swiper-slide:first-child img')[0])) {

                                let naturHeight = $('.single-swiper .swiper-slide:first-child img')[0].naturalHeight;
                                let naturWidth = $('.single-swiper .swiper-slide:first-child img')[0].naturalWidth;
                                let maxWidth = $('.single-swiper').outerWidth();
                                let newHeight = naturHeight * maxWidth / naturWidth;

                                if ($('.single-swiper .swiper-slide:first-child img')[0].naturalHeight > 0) {
                                    myStopFunction2();

                                    $('.single-swiper .swiper-slide').css('height', newHeight + 'px');
                                    $('.single-swiper .swiper-wrapper').css('height', newHeight + 'px');
                                }

                            }
                        }
                    }

                    let myVar2 = setInterval(myTimer2, 1000);

                    function myStopFunction2() {
                        clearInterval(myVar2);
                    }

                    if ($(".cross-selling-swiper-all").length) {
                        var crossSwiper2 = new Swiper(".cross-selling-swiper-all", {
                            spaceBetween: 10,
                            slidesPerView: 4,
                            loop: false,
                            navigation: {
                                nextEl: '.swiper-button-next-cross',
                                prevEl: '.swiper-button-prev-cross',
                            },
                            allowTouchMove: true,
                            breakpoints: {
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 10
                                },
                                586: {
                                    slidesPerView: 1,
                                    spaceBetween: 20
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 30
                                },
                                991: {
                                    allowTouchMove: false
                                }
                            }
                        });
                        // TODO: fix without window usage
                        window.dispatchEvent(new Event('resize'));

                        crossSwiper2.on('slideChange', function () {
                            // TODO: fix without window usage
                            window.dispatchEvent(new Event('resize'));
                        });
                    }

                    $('.single-crossselling__show-more').click(function () {
                        $('.single-crossselling__item').addClass("show-hidden-items");
                        $(this).addClass("d-none");
                        $('.single-crossselling__show-less').removeClass("d-none");
                    });

                    $('.single-crossselling__show-less').click(function () {
                        $('.single-crossselling__item').removeClass("show-hidden-items");
                        $(this).addClass("d-none");
                        $('.single-crossselling__show-more').removeClass("d-none");
                    });

                    // $(".single__more-details").click(function (el) {
                    //     el.preventDefault();
                    //
                    //     $(".single__details-table tr.toggle-hidden").toggleClass("hidden");
                    //
                    //     if ($(".single__more-info-icon").hasClass("fa-chevron-down")) {
                    //         $(".single__more-info-icon").removeClass("fa-chevron-down");
                    //         $(".single__more-info-icon").addClass("fa-chevron-up");
                    //     } else {
                    //         $(".single__more-info-icon").addClass("fa-chevron-down");
                    //         $(".single__more-info-icon").removeClass("fa-chevron-up");
                    //     }
                    // });

                    $('.single__footer-row--bubble').click(function () {

                        if ($(this).hasClass('bubble-open')) {
                            $(this).removeClass('bubble-open');
                            $('.single__footer-row--bubble .fa-chevron-down').addClass('fa-chevron-up').removeClass('fa-chevron-down');

                            $('.single__footer-row').animate({
                                bottom: '-' + $('.single__footer-row').outerHeight() + 'px'
                            }, 500, function () {
                                // Animation complete.
                            });
                        } else {
                            $(this).addClass('bubble-open');
                            $('.single__footer-row--bubble .fa-chevron-up').addClass('fa-chevron-down').removeClass('fa-chevron-up');

                            $('.single__footer-row').animate({
                                bottom: '0px'
                            }, 500, function () {
                                // Animation complete.
                            });
                        }

                    });

                    $('.single__open-product-details').click(function () {

                        if ($('.item-technical').hasClass('hidden')) {
                            $('.item-technical').removeClass('hidden');
                        } else {
                            $('.item-technical').addClass('hidden');
                        }

                    });

                    function validateEmail(email) {
                        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return re.test(String(email).toLowerCase());
                    }

                    $('#custom__contact-send').click(function (e) {

                        e.preventDefault();

                        var sel = '.single';

                        $('.has-error').removeClass('has-error');

                        var allFilled = true;
                        $.each($(sel + ' #contact-form input[required], ' + sel + ' #contact-form textarea[required]'), function (index, item) {
                            if ($(item).val() == '') {
                                allFilled = false;
                                return false;
                            }
                        });

                        if (!allFilled) {

                            $.each($(sel + ' #contact-form input[required], ' + sel + ' #contact-form textarea[required]'), function (index, item) {
                                if ($(item).val() == '') {
                                    $(item).closest('.input-unit').addClass('has-error');
                                }
                            });

                        } else {

                            if (!validateEmail($('[name="email"]').val())) {
                                $('[name="email"]').closest('div').addClass('has-error');
                                //NotificationService.error(
                                //    "Bitte überprüfen Sie Ihre E-Mail Adresse!"
                                //);
                            } else {

                                const mailObj =
                                    {
                                        name: $('[name="name"]').val(),
                                        userMail: $('[name="email"]').val(),
                                        subject: $('[name="subject"]').val(),
                                        orderId: $('[name="order"]').val(),
                                        message: $('[name="message"]').val(),
                                        type: 'contact',
                                        mailToMe: $('[name="mailToMe"]').val()
                                    };

                                const formData = serializeForm(that.$refs.contactForm);

                                $.ajax({
                                    url: 'https://www.froschkoenig24.de/rest/fk24/customer/contact/mail',
                                    type: 'POST',
                                    async: true,
                                    data: {
                                        data: formData,
                                        recipient: "info@froschkoenig24.com",
                                        template: "Ceres::Customer.Components.Contact.ContactMail",
                                        type: 'contact'
                                    },
                                    success: function (data, textStatus, jqXHR) {
                                        // success
                                        //console.log(data);
                                        //location.reload();

                                        NotificationService.success(
                                            that.$translate("Ceres::Template.contactSendSuccess")
                                        );
                                    },
                                    error: function (data) {
                                        //console.log(data);
                                    }
                                });
                            }
                        }

                    });

                    $('.angebot-send').click(function (e) {

                        e.preventDefault();

                        $('.has-error').removeClass('has-error');

                        var allFilled = true;
                        $.each($('#angebot input[required], #angebot textarea[required]'), function (index, item) {
                            if ($(item).val() == '' || ($(item).prop('checked') === false && $(item).attr('name') == 'angebot-datenschutz')) {
                                allFilled = false;
                                return false;
                            }
                        });

                        if (!allFilled) {

                            $.each($('#angebot input[required], #angebot textarea[required]'), function (index, item) {
                                if ($(item).val() == '') {
                                    $(item).closest('.form-group').find('label').addClass('has-error');
                                } else if ($(item).prop('checked') === false && $(item).attr('name') == 'angebot-datenschutz') {
                                    $(item).closest('.form-group').find('label').addClass('has-error');
                                }
                            });

                        } else {

                            const mailObj =
                                {
                                    anrede: $('[name="angebot-anrede"]').val(),
                                    userMail: $('[name="angebot-mail"]').val(),
                                    phone: $('[name="angebot-phone"]').val(),
                                    subject: 'Angebot anfordern',
                                    orderId: 'xxx',
                                    message: 'xxx',
                                    type: 'offer',
                                    mailToMe: 'xxx',
                                    name: $('[name="angebot-name"]').val(),
                                    lastname: $('[name="angebot-lastname"]').val(),
                                    nummer: $('[name="angebot-nummer"]').val(),
                                };

                            const formData = serializeForm($('#angebot-modal-wrapper .modal-body')[0]);

                            $.ajax({
                                url: 'https://www.froschkoenig24.de/rest/fk24/customer/contact/mail',
                                type: 'POST',
                                async: true,
                                data: {
                                    data: formData,
                                    recipient: "info@froschkoenig24.com",
                                    template: "Froschkoenig24::Customer.Components.Contact.ContactOffer",
                                    type: 'offer'
                                },
                                success: function (data, textStatus, jqXHR) {
                                    // success
                                    //console.log(data);
                                    $('#angebot').modal('hide');
                                },
                                error: function (data) {
                                    //console.log(data);
                                }
                            });

                        }

                    });

                    if ($('.show-variation-info').length) {
                        // 33251 - https://cdn03.plentymarkets.com/1wsscpvatptw/frontend/Domo/Mehr_Info/Details_Alle_4_Farini.jpg - attr 23

                        /*
                        23#https://cdn03.plentymarkets.com/1wsscpvatptw/frontend/Domo/Mehr_Info/Details_Alle_4_Farini.jpg+++
                        45#https://via.placeholder.com/250x350
                        * */
                        let free17content = $('.free17content').val();

                        if (free17content.indexOf("+++") > -1) {
                            free17content = free17content.split("+++");
                            for (let key in free17content) {
                                free17content[key] = free17content[key].split("#");
                            }

                            for (let key2 in free17content) {
                                // free17content[key2][0] = attr ID, [1] = bild link
                                free17content[key2][1] = free17content[key2][1].replace(/(\r\n|\n|\r)/gm, "");
                                free17content[key2][0] = free17content[key2][0].replace(/(\r\n|\n|\r)/gm, "");
                                let linkHtml = "<a class=\"show-variation-info\" data-lightbox=\"image-" + key2 + 1 + "\" href=\"" + free17content[key2][1] + "\"><i class='fa fa-info-circle'></i>&nbsp;Mehr erfahren</a>";
                                $(linkHtml).appendTo('.single__variation-selection-wrapper[data-attrid="' + free17content[key2][0] + '"] label');
                            }

                        } else if (free17content.indexOf("#") > -1) {
                            free17content = free17content.split("#");
                            // free17content[0] = attr ID, [1] = bild link
                            $('.show-variation-info').attr("href", free17content[1]);
                            $('.show-variation-info').appendTo('.single__variation-selection-wrapper[data-attrid="' + free17content[0] + '"] label');
                        } else {
                            $('.show-variation-info').appendTo('.single__variation-selection--zubehoer label');
                        }
                    }

                    if ($('.single__variation-selection').length) {
                        if ($('.single__variation-selection-wrapper').length === 0 && $('.single__variation-selection--variations').length === 0) {
                            $('.single__variation-selection + hr').remove();
                            $('.single__variation-selection').remove();
                        }
                    }

                    if ($('.single__variation-selection--zubehoer').length && ($('.single__variation-selection--zubehoer').html() == "<div><div></div></div>" ||
                        $('.single__variation-selection--zubehoer').html() == "<div></div>")) {
                        $('.single__variation-selection--zubehoer').remove();
                    }
                }, 1500);

                let stickyIsAdded = false;

                $(window).scroll(function () {
                    if (window.matchMedia("(min-width: 992px)").matches && !stickyIsAdded) {
                        if ($(".single-crossselling").html() == "") {
                            $("div[itemscope='itemscope']").addClass("sticky-itemscope");

                            if (!!document.querySelector(".item-bottom__item")) {
                                document.querySelector(".item-bottom.item-bottom--left-side.d-none.d-lg-flex").classList.add("item-bottom--sticky");
                                document.querySelector("div[itemscope='itemscope']").classList.add("sticky-with-margin");
                            }
                            stickyIsAdded = true;
                        }
                    }
                });
            },

            getDataField(field) {
                return get(this.currentVariation, field);
            },

            getFilteredDataField(field, filter) {
                if (!isNullOrUndefined(this.$options.filters[filter])) {
                    return this.$options.filters[filter](this.getDataField(field));
                }

            return this.getDataField(field);
        },

        // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
        hydrateChildren(nodes)
        {
            nodes.forEach(component => {
                if (component.$options.name === "lazy-hydrate")
                {
                    component.hydrate();
                }
                else if (component.$children.length)
                {
                    this.hydrateChildren(component.$children);
                }
            })
        }
    }
}
</script>
